<template>
  <v-layout justify-center>
    <v-flex flex md6>
      <v-card>
        <v-card-title class="title">Change your password</v-card-title>
        <v-card-text>
          <v-text-field
            ref="password"
            v-model="password"
            :append-icon="showPass ? 'visibility_off' : 'visibility'"
            :type="showPass ? 'text' : 'password'"
            name="password"
            :error-messages="errors.first('password')"
            data-vv-name="password"
            v-validate="'required|min:8'"
            label="Password"
            data-vv-as="Password"
            counter
            @click:append="showPass = !showPass"
          ></v-text-field>

          <v-text-field
            ref="passwordConfirmation"
            v-model="passwordConfirmation"
            :append-icon="showPass ? 'visibility_off' : 'visibility'"
            :type="showPass ? 'text' : 'password'"
            name="password_confirmation"
            :error-messages="errors.first('password_confirmation')"
            data-vv-name="password_confirmation"
            v-validate="'required|min:8|confirmed:password'"
            label="Confirm your password"
            data-vv-as="Password"
            counter
            @click:append="showPass = !showPass"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="changePassword()">Change password</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
import firebase from 'firebase';

export default {
  name: 'ChangePassword',
  props: {
    code: {
      type: String,
    },
  },
  data() {
    return {
      showPass: false,
      password: null,
      passwordConfirmation: null,
    };
  },
  methods: {
    async changePassword() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        try {
          await firebase.auth().confirmPasswordReset(this.code, this.password);
          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Password Updated!',
          });

          this.$router.push({ name: 'load-boards' });
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: 'Error updating your password, please request a new recovery email!',
          });
        }
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/User/ChangePassword.vue